import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from '../../utils/translate';
import { track } from '../../utils/track';
import { actions as appActions, AuthModalTab } from '../../actions/app';
import Modal from '../../components/Modal';
import FullRegistration from '../../components/FullRegistration';
import SignInForm from '../../components/SignInForm';
import PasswordResetForm from '../../components/PasswordResetForm';
import { selector } from './selector';
import { actions, lifecycle } from './actions';

import './index.scss';

interface Props {}

const b = b_.with('auth-modal');

const dispatchProps = {
  selectTab: actions.selectTab,
  close: appActions.hideAuthModal,
};

type Enhanced = Props & InjectedTranslateProps & ReturnType<typeof selector> & typeof dispatchProps;

const enhance = compose<Enhanced, Props>(
  translate,
  track({ activate: lifecycle.activate }),
  connect(selector, dispatchProps)
);

class AuthenticationView extends React.Component<Enhanced> {
  render() {
    const { close } = this.props;

    return (
      <Modal className={b()} onClose={close} data-testid="auth-modal">
        <section className={b('section')}>
          {this.renderHeader()}
          {this.renderContent()}
        </section>
      </Modal>
    );
  }

  private renderHeader() {
    const { t, currentTab, isHeaderVisible, selectTab } = this.props;

    if (!isHeaderVisible) {
      return null;
    }

    const secondTab: AuthModalTab = currentTab === 'signin' ? 'signup' : 'signin';

    return (
      <div className={b('tabs')}>
        <h2>{t(currentTab)}</h2>
        <button
          className={b('btn')}
          onClick={() => selectTab(secondTab)}
          data-gtm={`authform-${secondTab}-tab`}
        >
          {t(secondTab)}
        </button>
      </div>
    );
  }

  private renderContent() {
    const { currentTab, source, landing } = this.props;
    switch (currentTab) {
      case 'signin':
        return <SignInForm />;
      case 'signup':
        return (
          <FullRegistration
            source={source || 'mainMenu'}
            landing={landing || 'desktopMainMenuRegistration'}
          />
        );
      case 'restore':
        return <PasswordResetForm />;
      default:
        return null;
    }
  }
}

export default enhance(AuthenticationView);
